import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2016 } from "../../../../data/Convenios/dataConvenios";

const Convenios2016 = () => <ConveniosYearPage year={2016} data={convenios2016} />;

export default Convenios2016;